import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "smallArrowLeftGold",
  "use": "smallArrowLeftGold-usage",
  "viewBox": "0 0 26 19",
  "content": "<symbol viewBox=\"0 0 26 19\" xmlns=\"http://www.w3.org/2000/svg\" id=\"smallArrowLeftGold\"><path d=\"m3.2 13 5.6 5.7m16.2-9.2h-25l9-8.7\" fill=\"none\" stroke=\"#9c7446\" stroke-miterlimit=\"10\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol